import DriverBanner from "../../services/api/DriverBanner";
import DriverServices from "../../services/api/DriverServices";

import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in driver banner actions :", err);
}

export const resetToInitialState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE,
    payload,
  };
};

export const resetState = (state) => async (dispatch) => {
  let payload = {
    state: state,
  };
  dispatch(resetToInitialState(payload));
};

export const removeLastEvaluatedKeyFromList = () => {
  return {
    type: ActionTypes.REMOVE_LAST_EVALUATED_KEY_FROM_LIST,
  };
};
export const emptyEvaluatedKeyList = () => {
  return {
    type: ActionTypes.EMPTY_LAST_EVALUATED_KEY_LIST,
  };
};
export const updateEvaluationKeyList = () => {
  return async (dispatch) => {
    dispatch(removeLastEvaluatedKeyFromList());
  };
};
export const clearEvaluatedKeyList = () => {
  return async (dispatch) => {
    dispatch(emptyEvaluatedKeyList());
  };
};

export const setDriverBannerList = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_BANNER_LIST,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_DRIVER_BANNER,
    payload,
  };
};

export const setBannerTargetAudience = (payload) => {
  return {
    type: ActionTypes.SET_TARGET_AUDIENCE,
    payload,
  };
};

export const setTargetableBusiness= (payload) => {
  return {
    type: ActionTypes.SET_TARGETABLE_BUSINESS,
    payload,
  };
};

export const getBannerTargetAudience = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverBanner.fetchBannerTargetAudience(id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setBannerTargetAudience(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getTargetableBusiness = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverServices.exclusiveDriverService();
    dispatch(setLoader(false));
    if (response) {
      console.log("response", response);
      dispatch(setTargetableBusiness(response?.driver_services ?? []));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getDriverBannerList =
  ({ filters = [], pageRequest = {} }) =>
  async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await DriverBanner.fetchBannerList({
        filters,
        pageRequest,
      });
      dispatch(setLoader(false));
      if (response) {
        dispatch(setDriverBannerList(response));
        dispatch(setActiveFilters(filters));
        if (filters.length === 0) {
          dispatch(resetState("activeFilters"));
        }
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const setBannerDetails = (payload) => {
  return {
    type: ActionTypes.SET_BANNER_DETAILS,
    payload,
  };
};

export const getBannerDetails = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverBanner.fetchBannerDetails(id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setBannerDetails({ driver_banner_details: response }));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

